import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Florencia',
  city: 'Córdoba'
}, {
  name: 'Gabriela',
  city: 'Rosario'
}, {
  name: 'Carolina',
  city: 'Mendoza'
}, {
  name: 'Valeria',
  city: 'La Plata'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}, {
  name: 'Lucía',
  city: 'Tucumán'
}, {
  name: 'Martina',
  city: 'Neuquén'
}, {
  name: 'Camila',
  city: 'Santa Fe'
}, {
  name: 'Valentina',
  city: 'Salta'
}, {
  name: 'Roberto',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Córdoba'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      const nextDelay = Math.random() * (15000 - 8000) + 8000 + 4000;
      setTimeout(showPopup, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 animate-slide-in-left" data-id="element-16">
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-3 max-w-xs md:max-w-sm" data-id="element-17">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-18">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-19" />
        </div>
        <div data-id="element-20">
          <p className="text-sm font-bold text-gray-900" data-id="element-21">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-22">
            acaba de comprar el MegaPack Nutrición
          </p>
          <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-23">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}